import "../styles/dropdown.scss";
import React, { useState } from 'react';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleDown} from "@fortawesome/free-solid-svg-icons";

export default function Dropdown(props) {
  const [isOpen, setIsOpen] = useState(false);

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const closeDropdown = () => {
    setIsOpen(false);
  };

  return (
    <div 
      className = {props.isSlightlyScrolled ? "dropdownContainer" : "dropdownContainer nobg"}
      onMouseEnter={toggleDropdown} 
      onMouseLeave={closeDropdown}
    >
        <div className="textDropdown">
            <a onClick={toggleDropdown}>
                {props.title}
            </a>
            <FontAwesomeIcon icon={faAngleDown} />
        </div>
      {isOpen && (
        <div className="dropdownMenu">
          {props.items && Object.entries(props.items).map(([item, value], index) => 
          typeof value === "string" ? (
            <a href={value} className="menuItem">{item}</a>
          ) : (
            <a href="#" onClick={(e) => { e.preventDefault(); value(); }} className="menuItem">{item}</a>
          ))}
        </div>
      )}
    </div>
  );
}